<template>
	<div>
		<a-form-model ref="addForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }"  :model="theObj" :rules="rules">
				<a-form-model-item label="公司名称"  prop="companyName">
					<a-input v-model="theObj.companyName"/>
				</a-form-model-item>
				<a-form-model-item label="公司地址"  prop="companyAddr">
					<a-input v-model="theObj.companyAddr"/>
				</a-form-model-item>
				<a-form-model-item label="公司标识"  prop="mark">
					<a-input v-model="theObj.mark" />
				</a-form-model-item>
				<a-form-model-item label="邮箱主机" prop="emailHost">
					<a-input v-model="theObj.emailHost" />
				</a-form-model-item>
				<a-form-model-item label="邮箱用户名"  prop="emailUser">
					<a-input v-model="theObj.emailUser"/>
				</a-form-model-item>
				<a-form-model-item label="邮箱密码"  prop="emailPassword">
					<a-input-password v-model="theObj.emailPassword"/>
				</a-form-model-item>
				<a-form-model-item label="缴费地址"  prop="payAddr">
					<a-input v-model="theObj.payAddr"/>
				</a-form-model-item>
				<a-form-model-item label="查询电话"  prop="telephone">
					<a-input v-model="theObj.telephone"/>
				</a-form-model-item>
				<a-form-model-item label="备注">
					<a-textarea v-model="theObj.remark"  :auto-size="{ minRows: 3, maxRows: 6 }"/>
				</a-form-model-item>
				<a-form-model-item label="管理员姓名"  prop="adminName">
					<a-input v-model="theObj.adminName"/>
				</a-form-model-item>
				<a-form-model-item label="管理员登录名">
					<a-input v-model="theObj.loginName"/>
				</a-form-model-item>
		</a-form-model>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				submitFlag:false,
				theObj:{
					companyName:null,
					companyAddr:null,
					mark:null,
					emailHost:null,
					emailUser:null,
					emailPassword:null,
					payAddr:null,
					telephone:null,
					remark:null,
					adminName:null,
					loginName:null,
				},
				rules:{
					companyName:[{required:true,message:'请输入公司名称',trigger: 'blur'}],
					companyAddr:[{required:true,message:'请输入公司地址',trigger: 'blur'}],
					mark:[{required:true,message:'请输入公司标识',trigger: 'blur'}],
					emailHost:[{required:true,message:'请输入邮箱主机',trigger: 'blur'}],
					emailUser:[{required:true,message:'请输入邮箱用户名',trigger: 'blur'}],
					emailPassword:[{required:true,message:'请输入邮箱密码',trigger: 'blur'}],
					payAddr:[{required:true,message:'请输入交费地址',trigger: 'blur'}],
					telephone:[{required:true,message:'请输入查询电话',trigger: 'blur'}],
					adminName:[{required:true,message:'请输入管理员姓名',trigger: 'blur'}],
				},
			}
		},
		methods:{
			onClose:function(flag){
				this.$emit('cancelAdd');
				if(flag){
					this.$emit('refreshList');
				}
			},
			onSubmit:function(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						this.doSubmit();
					} else {
						return false;
					}
				});
			},
			doSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.ADD_WATER_COMPANY_URL);
				this.Api.fetchPostWithForm(url,this.theObj).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('新增水司成功');
						this.onClose(true);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.submitFlag = false;
					console.log(error);
				});
			}
		},
	}
</script>

<style>
</style>
